import React from "react";

import { AiFillGithub } from "react-icons/ai";
function Github() {
  return (
    <div className="flex flex-col">
      <div className="flex gap-2 items-center justify-left section__contentTitle">
        Github
        <span className="text-xl font-bold text-black dark:text-textColorLight">
          <AiFillGithub></AiFillGithub>
        </span>
      </div>
      <img
        className="hidden w-full dark:block"
        src="https://github-stats-extended.vercel.app/api?username=pranavmappoli&show_icons=true&theme=transparent&hide_border=true&icon_color=6e57e0&hide_title=true&title_color=6e57e0&include_all_commits=true&text_color=a19fad&line_height=30"
        alt="github-status"
      />
      <img
        className="w-full dark:hidden"
        src="https://github-stats-extended.vercel.app/api?username=pranavmappoli&show_icons=true&theme=transparent&hide_border=true&icon_color=6e57e0&hide_title=true&title_color=6e57e0&include_all_commits=true&text_color=6d6a7c&line_height=30"
        alt="github-status"
      />
      <div>
        <img
          className="w-full h-full"
          src="https://github-stats-extended.vercel.app/api/top-langs/?username=pranavmappoli&layout=compact&theme=transparent&hide_border=true&icon_color=6e57e0&hide_title=true"
          alt="languages"
        />
      </div>
    </div>
  );
}

export default Github;
